import axios from 'axios';
import EspecialidadesTabla from '../types/EspecialidadesTabla';

async function InsertarEspecialidad(EspecialidadNueva: EspecialidadesTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_especialidad";
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "especialidad": {
                    "especialidad": EspecialidadNueva.especialidad,
                    "habilitado": EspecialidadNueva.habilitado,
                    "dado_de_baja": EspecialidadNueva.dado_de_baja
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarEspecialidad;